export const ru = {
    title: 'Кажется, данная компания ещё не пользуется нашим сервисом',
    description: 'Если ваша компания хочет начать пользоваться нашим сервисом,',
    contact_us: 'свяжитесь с нами',
};
